import type { ReactNode } from 'react'
import { AlertCircle } from 'lucide-react'
import { cn } from '../lib/cn.ts'
import { Button } from './button.tsx'

export function Alert({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2.5 rounded-control border border-warn-line bg-warn-tint px-3.5 py-3 text-[13.5px] text-warn-ink text-balance-pretty',
        className,
      )}
    >
      <AlertCircle className="mt-0.5 size-4 shrink-0" />
      <span>{children}</span>
    </div>
  )
}

export function EmptyState({ title, description }: { title: string; description?: string }) {
  return (
    <div className="px-5 py-9 text-center">
      <div className="mb-1 text-[15px] font-medium">{title}</div>
      {description && <div className="text-[14px] text-ink-muted text-balance-pretty">{description}</div>}
    </div>
  )
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="flex flex-col items-start gap-3 px-5 py-9">
      <Alert className="w-full">{message}</Alert>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          Попробовать снова
        </Button>
      )}
    </div>
  )
}

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('animate-pulse rounded-md bg-line-soft', className)} />
}
